import type { LoginError } from './types'

export class LoginRequestError extends Error {
  readonly loginError: LoginError

  constructor(loginError: LoginError) {
    super(`Failed to login: ${loginError.type}`)
    this.name = 'LoginRequestError'
    this.loginError = loginError
  }
}
